import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { AlertMessageType } from '@ux/components/alert-message/alert-message-type';

@Component({
  selector: 'app-fare-info',
  templateUrl: './fare-info.component.html',
  styleUrls: ['./fare-info.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FareInfoComponent {

  @Input() textFare: string;
  @Input() extraTextFare: string;

  public alertType: AlertMessageType = AlertMessageType.WARNING;

  constructor() { }

  get hasFareInfo(): boolean {
    return this.hasExtraTextFare || this.hasTextFare;
  }

  get hasTextFare(): boolean {
    return !!this.textFare;
  }

  get hasExtraTextFare(): boolean {
    return !!this.extraTextFare;
  }

  get shouldDisplayExtraTextFare(): boolean {
    return !!this.hasExtraTextFare && !this.isSameTextFare;
  }

  private get isSameTextFare(): boolean {
    return this.extraTextFare?.normalize() === this.textFare?.normalize();
  }

}
